<template>
    <div class="tiers" v-view.once="initTiers" :class="stateObj">
        <div class="tiers_options">
             <div class="tiers__col tiers__col--fade-in">
                <div class="tiers__el">
                    <div class="tiers__label"><b>{{ $t("message.tiers.t4.label") }}</b></div>
                    <div class="tiers__content">
                        <div class="tiers__price">
                            <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t4.label'))">
                                <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t4.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="tiers__desc" v-html="$t('message.tiers.t4.desc')"></div>
                </div>
            </div>
            <div class="tiers__col tiers__col--fade-in">
                <div class="tiers__el">
                    <div class="tiers__label"><b>{{ $t("message.tiers.t1.label") }}</b></div>
                    <div class="tiers__content">
                        <div class="tiers__price">
                            <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t1.label'))">
                                <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t1.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="tiers__desc" v-html="$t('message.tiers.t1.desc')"></div>
                </div>
            </div>
            <div class="tiers__col tiers__col--fade-in">
                <div class="tiers__el">
                    <div class="tiers__label"><b>{{ $t("message.tiers.t2.label") }}</b></div>
                    <div class="tiers__content">
                        <div class="tiers__price">
                            <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t2.label'))">
                                <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t2.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="tiers__desc" v-html="$t('message.tiers.t2.desc')"></div>
                </div>
            </div>
            <div class="tiers__col tiers__col--fade-in">
                <div class="tiers__el">
                    <div class="tiers__label"><b>{{ $t("message.tiers.t3.label") }}</b></div>
                    <div class="tiers__content">
                        <div class="tiers__price">
                            <a href="javascript:void(0)" v-scroll-to="'#calc'" @click.stop="tierClick($t('message.tiers.t3.label'))">
                                <span class="tiers__price--amount">{{$t("message.currencySymbol")}}{{$t("message.tiers.t3.cost")}}<span class="tiers__price--currency">{{$t("message.currencyDesc")}}</span></span>
                                <span class="tiers__price--label">{{$t("message.tiers.terms")}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="tiers__desc" v-html="$t('message.tiers.t3.desc')"></div>
                </div>
            </div>
        </div>
        <Features></Features>
        <div class="tiers__actions">
            <div class="tiers__actions_button">
                <a href="/content/dam/citrix/en_us/documents/data-sheet/citrix-workspace-feature-matrix.pdf" target="_blank" class="ctx-button primary ctx-blue ctx-medium-btn"><span>{{$t("message.tiers.btn1")}}</span></a>
            </div>
        </div>
    </div>

</template>

<script>

    import Features from './Features'
    import { bus } from '../bus'

    export default {
        name: 'tiers',
        components: {Features},
        data(){
            return{
                stateObj:{
                    init: false
                }
            }
        },
        methods: {
            initTiers(){
                this.stateObj.init = true
            },
            tierClick(tier){
                bus.$emit("tierClick", tier)
            }
        }
    }

</script>